import { Configuration, PopupRequest, RedirectRequest } from "@azure/msal-browser";

// Detect mobile to use sessionStorage (session-only auth)
// Desktop uses localStorage (persistent auth across browser restarts)
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || window.innerWidth < 768;

console.log('[MSAL Config] Device type:', isMobile ? 'Mobile' : 'Desktop');
console.log('[MSAL Config] Cache location:', isMobile ? 'sessionStorage (session-only)' : 'localStorage (persistent)');

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${
      import.meta.env.VITE_AZURE_TENANT_ID || "common"
    }`,
    // Use window.location.origin to support mobile access via IP address
    // Falls back to env var for local dev if needed
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // Mobile: sessionStorage for session-only auth (reliable, no cache issues)
    // Desktop: localStorage for persistent auth (works fine on desktop)
    cacheLocation: isMobile ? "sessionStorage" : "localStorage",
    storeAuthStateInCookie: true, // Required for mobile redirect flows
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        // Log ALL MSAL messages for debugging mobile issues
        const logLevels = ['ERROR', 'WARNING', 'INFO', 'VERBOSE', 'TRACE'];
        const levelName = logLevels[level] || 'UNKNOWN';
        console.log(`[MSAL-${levelName}]`, message);
      },
    },
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: RedirectRequest | PopupRequest = {
  scopes: [`${import.meta.env.VITE_AZURE_CLIENT_ID}/.default`],
};